import { createAction } from '@reduxjs/toolkit';

/** Mirrors backend's `AuthenticatedUser`/`MeProfile` (docs/PLAN.md §6) — no shared-package type
 *  exists for it (that DTO is backend-internal), so the frontend keeps its own copy. */
export interface UserProfile {
  id: string;
  email: string | null;
  phone: string | null;
  firstName: string;
  lastName: string;
  middleName: string | null;
  businessName: string | null;
  locale: string;
  mustChangePassword: boolean;
  emailVerifiedAt: string | null;
  phoneVerifiedAt: string | null;
}

/**
 * Cross-layer action bridge. `shared` sits below every other layer in the FSD import direction,
 * so it can't dispatch an action creator owned by an `app`/`entities`/`features` slice directly —
 * these are the agreed-upon contract instead: any layer may dispatch them (they only need
 * `shared`), and `app/store`'s slices handle them via `extraReducers`.
 */
export const credentialsUpdated = createAction<{ accessToken: string; user: UserProfile }>(
  'session/credentialsUpdated',
);
export const sessionCleared = createAction('session/sessionCleared');
/** Dispatched right BEFORE `sessionCleared` on an explicit sign-out (logout / logout-all / account
 *  deletion). */
export const loggedOut = createAction('session/loggedOut');
